<template>
    <div class="statistics">
        <div class="statistics-content">
            <div class="statistics-item" v-for="(item,i) in itemList" :key="i" :class="item.class" v-loading="item.loading">
                <div class="item-container">
                    <div class="item-btn" @click="btnClick(item)">{{item.typeText}}</div>
                </div>
                <div class="item-title">{{item.title}}</div>
                <div class="item-main">
                    <div class="item-main--num">
                        <span>{{item.allNum}}</span>次
                    </div>
                    <img :src="item.imgUrl" :alt="item.title">
                </div>
                <div class="item-bottom">
                    <span 
                        v-for="(items,index) in item.bottomList" 
                        :key="index"
                    >{{items.text}}
                        <i :class="items.class">{{items.num}}</i>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    apiHomeStatisticsQueryAcceptNum,
    apiHomeStatisticsQuerySiteNum,
    apiHomeStatisticsQueryExperttNum,
    apiHomeStatisticsQueryAllopatricNum
} from '@/server/new.js';
export default {
    data() {
        return {
            itemList: [
                {
                    class: 'item-blue',
                    title: '项目见证-受理',
                    itemType: 1,
                    bottomList: [{text:'工程',class:'gc',num: 0},{text:'采购',class:'cg',num: 0},{text:'平均耗时',class:'hs',num: 0}],
                    imgUrl:require('@/assets/images/home/statistics-1.png'),
                    type: 1,
                    typeText: '本月',
                    allNum: 0, //总数
                    loading: false
                },
                {
                    class: 'item-skyblue',
                    title: '场地预约',
                    itemType: 2,
                    bottomList:[{text:'工程',class:'gc',num: 0},{text:'采购',class:'cg',num: 0},{text:'平均耗时',class:'hs',num: 0}],
                    imgUrl:require('@/assets/images/home/statistics-2.png'),
                    type: 1,
                    typeText: '本月',
                    allNum: 0, //总数
                    loading: false
                },
                {
                    class: 'item-purple',
                    title: '专家抽取',
                    itemType: 3,
                    bottomList:[{text:'工程',class:'gc',num: 0},{text:'采购',class:'cg',num: 0},{text:'平均耗时',class:'hs',num: 0}],
                    imgUrl:require('@/assets/images/home/statistics-3.png'),
                    type: 1,
                    typeText: '本月',
                    allNum: 0, //总数
                    loading: false
                },
                {
                    class: 'item-lakeblue',
                    title: '远程异地项目',
                    itemType: 4,
                    bottomList:[{text:'工程',class:'gc',num: 0},{text:'采购',class:'cg',num: 0}],
                    imgUrl:require('@/assets/images/home/statistics-4.png'),
                    type: 1,
                    typeText: '本月',
                    allNum: 0, //总数
                    loading: false
                },
            ]
        }
    },
    created() {
        this.apiHomeStatisticsQueryAcceptNum();
        this.apiHomeStatisticsQuerySiteNum();
        this.apiHomeStatisticsQueryExperttNum();
        this.apiHomeStatisticsQueryAllopatricNum();
    },
    methods: {
        apiHomeStatisticsQueryAcceptNum(temp=1) { //项目见证-受理
            this.loadingHandler(1,true)
            apiHomeStatisticsQueryAcceptNum(temp).then(({data}) => {
                this.dataHandler(1,temp,data)
            }).finally(() => {
                this.loadingHandler(1,false)
            })
        },
        apiHomeStatisticsQuerySiteNum(temp=1) { //场地预约
            this.loadingHandler(2,true)
            apiHomeStatisticsQuerySiteNum(temp).then(({data}) => {
                this.dataHandler(2,temp,data)
            }).finally(() => {
                this.loadingHandler(2,false)
            })
        },
        apiHomeStatisticsQueryExperttNum(temp=1) { //专家抽取
            this.loadingHandler(3,true)
            apiHomeStatisticsQueryExperttNum(temp).then(({data}) => {
                this.dataHandler(3,temp,data)
            }).finally(() => {
                this.loadingHandler(3,false)
            })
        },
        apiHomeStatisticsQueryAllopatricNum(temp=1) { // 远程异地项目
            this.loadingHandler(4,true)
            apiHomeStatisticsQueryAllopatricNum(temp).then(({data}) => {
                this.dataHandler(4,temp,data)
            }).finally(() => {
                this.loadingHandler(4,false)
            })
        },
        loadingHandler(type,flag) { //loading处理
            this.itemList.map(item => {
                if(item.itemType === type) {
                    item.loading = flag;
                }
            })
        },
        dataHandler(type,temp,data) {
            this.itemList.map(item => {
                if(item.itemType === type) {
                    item.type = temp;
                    item.typeText = temp === 2?'本年':'本月';
                    item.allNum = data.data.allNum
                    item.bottomList.map(items => {
                        if(items.class === 'gc') {
                            items.num = data.data.gcNum
                        }
                        if(items.class === 'cg') {
                            items.num = data.data.cgNum
                        }
                        if(items.class === 'hs') {
                            items.num = data.data.averageTime
                        }
                    })
                }
            })
        },
        btnClick(row) {
            let temp = 1;
            if(row.type === 1) {
                temp = 2;
            }
            if(row.type === 2) {
                temp = 1;
            }
            // row.itemType === 1 && this.apiHomeStatisticsQueryAcceptNum(temp);
            // row.itemType === 2 && this.apiHomeStatisticsQuerySiteNum(temp);
            // row.itemType === 3 && this.apiHomeStatisticsQueryExperttNum(temp);
            this.apiHomeStatisticsQueryAcceptNum(temp);
            this.apiHomeStatisticsQuerySiteNum(temp);
            this.apiHomeStatisticsQueryExperttNum(temp);
            this.apiHomeStatisticsQueryAllopatricNum(temp);
        },
        getQueryAllopatricNum() {

        }
    }
}
</script>

<style lang="less" scoped>
.statistics {
    display: flex;
    justify-content: space-between;
    height: 120px;
    // background-color: #fff;
    // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    // border-radius: 4px;
    // overflow: hidden;
    .statistics-content {
        // width: calc(100% - 32px);
        // padding: 10px;
        width: 100%;
        display: flex;
        .statistics-item {
            flex: 1;
            background-color: #fff;
            box-shadow: 0 0 12.42px 0 #ced9eb;
            margin-right: 20px;
            border-radius: 8px;
            padding: 16px 24px 12px 24px;
            position: relative;
            &:after {
                content: '';
                width: 100%;
                height: 4px;
                background: linear-gradient(90deg, #2a61ef 0%, #2a61ef 100%);
                position: absolute;
                left: 0;
                bottom: 0;
                border-radius: 0 0 30px 30px;
            }
            &.item-skyblue:after {
                background: linear-gradient(132.9deg, #3aacff 0%, #3adcff 100%);
            }
            &.item-purple:after {
                background: #8A48DF;
            }
            &.item-lakeblue:after {
                background: #13C2C2;
            }
            &:last-child {
                margin-right: 0;
            }
            .item-container {
                position: absolute;
                right: 16px;
                top: 14px;
                z-index: 9;
                .item-btn {
                    width: 28px;
                    height: 18px;
                    border: 1px solid @--color-primary;
                    font-size: 12px;
                    color: @--color-primary;
                    text-align: center;
                    line-height: 16px;
                    background: #fff;
                    cursor: pointer;
                    position: relative;
                    &:hover {
                        opacity: .8;
                    }
                }
                &:after {
                    content: '';
                    width: 100%;
                    height: 100%;
                    border: 1px solid rgb(220, 220, 220);
                    position: absolute;
                    z-index: -1;
                    top: -3px;
                    right: -3px;
                }
            }
            .item-title {
                font-size: 16px;
                font-weight: 400;
            }
            .item-main {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 10px 0;
                .item-main--num {
                    color: #A4A8AC;
                    span {
                        font-size: 32px;
                        color: #122039;
                        font-weight: 500;
                        margin-right: 8px;
                    }
                }
            }
            .item-bottom {
                span {
                    // margin-right: 24px;
                    margin-right: 10%;
                    font-size: 12px;
                    color: #757B82;
                    font-weight: 400;
                    &:last-child {
                        margin-right: 0;
                    }
                }
                i {
                    font-style: normal;
                    &.gc {
                        color: #2568EC;
                    }
                    &.cg {
                        color: #3ABEFF;
                    }
                    &.hs {
                        color: #FF9900;
                    }
                    &.dgc {
                        color: #2568EC;
                    }
                    &.dcg {
                        color: #3ABEFF;
                    }
                }
            }
        }
    }
    .statistics-btn {
        width: 32px;
        display: flex;
        flex-direction: column;
        span {
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            height: 50%;
            cursor: pointer;
            font-size: 16px;
            padding: 0 6px;
            &.active,&:hover {
                background-color: #2568ec;
                color: #fff;
            }
        }
    }
}
</style>